"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRestoreNotification = useRestoreNotification;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _headers = require("../constants/headers");
var _logger = require("../logger");
var _isOnBehalf = require("../utils/isOnBehalf");
var _withHandePost = require("../utils/withHandePost");
const isDevelopment = process.env.NODE_ENV === 'development';
const logger = _logger.mainLogger.createChild('useUndeleteNotificationQuery');
function useRestoreNotification() {
  const {
    token,
    customerId
  } = (0, _auth.useToken)();
  const client = (0, _globalApiClientReact.useApiClient)();

  /** When executed it restores the provided notification */
  const mutation = (0, _react.useCallback)(async notification => {
    const onBehalf = (0, _isOnBehalf.isOnBehalf)(token);
    if (!isDevelopment && onBehalf || notification.notificationId === undefined) {
      return true;
    }
    return (0, _withHandePost.withHandlePost)((0, _globalApiClientReact.createCustomerInAppNotificationUndelete)(client, customerId, notification.notificationId, {
      [_headers.HEADER_KEY_X_CLIENT_APPLICATION]: _headers.HEADER_VALUE_X_CLIENT_APPLICATION
    }), {
      onError(error) {
        logger.error(new Error('Failed to undelete a notification', {
          cause: error
        }));
      }
    });
  }, [client, customerId, token]);
  return [mutation];
}
